export const dk = {
    // Login screen
    modal_login_capital: 'LOG IND',
    placeholder_email_address: 'e-mail mappe',
    placeholder_password: 'adgangskode mappe',
    tooltip_forgot_password: 'glemt din adgangskode?',
    log_in: 'Log ind',

    // Register screen
    modal_signup_capital: 'TILMELD DIG',
    placeholder_repeat_password: 'gentag adgangskoden',
    agree: 'Jeg accepterer ',
    terms: 'Vilkårene',
    modal_register_capital: 'REGISTRERE DIG',
    full_name: 'Fulde navn',

    // Price options
    choose_price: 'VÆLG DIN PRIS',
    subscription_price: 'Abonnement',
    asset_price: 'Aktiv',
    paywall_subscription_text:
        'Du kan til enhver tid afbestille dit abonnement.',
    modal_back: 'TILBAGE',
    next_button: 'NÆSTE',

    // Payments screen
    pay: 'BETAL',
    pay_with: 'BETAL MED PAYPAL',
    credit_card: 'kreditkort',
    payment_pay: 'Betal',
    payment_price: 'Pris',
    placeholder_voucher_code: 'kuponkode',
    placeholder_voucher: 'tilføj kupon',
    card_number: 'kortnummer',
    cardholder_name: 'kortholders navn',

    // Forgot password
    forgot_pass_text:
        'Vi har sendt en e-mail med et link til at nulstille din adgangskode',
    remember_pass: 'Husk min adgangskode?',
    reset: 'NULSTIL',

    // Set new password
    modal_enter_your_new_password: 'Indtast din nye adgangskode.',
    modal_please_check_your_email:
        'Tjek din e-mail og kopiere token for at fortsætte.',
    placeholder_token: 'token',
    new_password: 'ny adgangskode',
    repeat_new_password: 'gentag ny adgangskode',
    cancel: 'annullere',
    set: 'INDSTIL',

    // Change password
    update: 'opdater',
    change_pass: 'Change password',

    // Account
    user_menu_my_account: 'Min konto',
    member_since: 'Medlem siden',
    purchases: 'Mine køb',
    subscriptions: 'Mine abonnementer',
    account_details: 'Kontooplysninger',
    export_data: 'Eksporter mine oplysninger',
    delete_account: 'Slet min konto',

    // Purchases/Subscriptions
    purchases_link: 'Køb',
    subscriptions_link: 'Abonnementer',
    subscriptions_text:
        'These are all the assets you have purchased and how long you have access to it.',
    purchase_history: 'Købshistorik',
    purchased: 'Købt',
    name: 'navn',
    active: 'aktiv',
    inactive: 'Inactive',
    canceled: 'annulleret',
    type: 'Type',
    next_transaction: 'Næste transaktion',
    cancel_subscription: 'Annullere dit abonnement >',
    subscriptions_active: 'Aktive abonnementer',
    expires_at: 'Udløber den',
    no_more_subscriptions: 'Der er ikke flere abonnementer.',
    no_available_subscriptions: 'Der er ingen tilgængelige abonnementer.',
    no_more_active_accesses: 'Der er ikke flere aktive adgange.',
    no_more_inactive_accesses: 'Der er ikke flere inaktive adgange.',
    no_available_active_accesses: 'Der er ingen tilgængelige aktive adgange.',
    no_available_inactive_accesses:
        'Der er ingen tilgængelige inaktive adgange.',
    subscription: 'Subscription',
    free_trial: 'Free Trial',
    cancel_subscription_header:
        'Are you sure you want to cancel your subscription?',
    cancel_subscription_paragraph_first:
        'This will end your subscription for the',
    cancel_subscription_paragraph_second:
        'You will still have access to everything until the active period ends on the',
    cancel_subscription_confirm: 'Yes, cancel',
    will_end: 'Subscription will end',

    // Export data screen
    export_question:
        'Er du sikker på, at du vil eksportere dine kontooplysninger?',
    export: 'eksport',
    first_export:
        'Eksporter kontooplysninger funktionen, vil eksportere alle dine personlige oplysninger fra din konto. Dette omfatter følgende:',
    second_export: 'Dine personlige oplysninger',
    third_export: 'Liste over dine log ind optegnelser',
    fourth_export: 'Liste over dine abonnementer',
    fifth_export: 'Liste over dine betalinger',
    sixth_export: 'Liste over dine adgange til premium-indhold',
    last_export:
        'Eksporten vil blive sendt til din e-mailadresse som en vedhæftet fil.',

    // Delete account screen
    delete_question: 'Er du sikker på du vil slette din konto?',
    delete: 'slet',
    confirm: 'BEKRÆFT',
    first_delete:
        'Slet konto funktionen, vil slette alle dine personlige oplysninger i systemet. Dette omfatter følgende:',
    second_delete: 'De personlige oplysninger, du angav under registreringen ',
    third_delete:
        ' Placering og enhedsoplysninger, vi indsamlede under godkendelsesprocessen',
    fourth_delete:
        'Alle andre personlige oplysninger, der er opbevaret i andre dele af vores database',
    fifth_delete:
        'De eneste personlige oplysninger vi opbevarer i systemet, er dem, der er en del af transaktionerne og abonnementerne som følge af andre juridiske krav, som vi skal overholde.',
    sixth_delete:
        'Ud over sletning af dine oplysninger, vil din konto også blive deaktiveret, hvilket betyder at alle dine aktive abonnementer vil blive annulleret, alle dine aktive adgange til aktiver vil blive tilbagekaldt, og alle dine aktive log ind-sessioner, herunder denne vil blive opsagt. Du vil ikke længere kunne købe aktiver på denne hjemmeside. Dine kontooplysninger vil ikke længere være tilgængelig på nogen liste til vores medarbejdere.',
    seventh_delete:
        'Denne handling kan tage 1-2 dage at fuldføre hvorefter en bekræftelsesmail vil blive sendt til din e-mailadresse. Din e-mailadresse vil blive slettet fra vores system efter vellykket levering.',

    // Inputs validation
    required_field: 'Obligatorisk felt',
    email_field: 'indtast en korrekt e-mailadresse',
    number_field: 'Værdien skal være et tal',
    matchPass: 'adgangskoden er ikke den samme',
    minpass_field: 'skal være på mindst 8 tegn',
    minname_field: 'skal være på mindst 2 tegn',

    // Footer
    modal_terms: 'Vilkår',
    modal_privacy: 'Privacy',
    modal_more: 'MERE',
    modal_faq: 'FAQ',
    modal_protected: 'Hvad er det?',
    logout: 'Log ud',
    details: 'Mine oplysninger',
    preview_protected_by_inplayer: 'Hvad er det?',
    modal_support: 'Support',

    dlc_download: 'download',
};



// WEBPACK FOOTER //
// ./src/i18n/danish.js